import { render, staticRenderFns } from "./DiscordMessage.vue?vue&type=template&id=1269b6d4&scoped=true&"
import script from "./DiscordMessage.vue?vue&type=script&lang=js&"
export * from "./DiscordMessage.vue?vue&type=script&lang=js&"
import style0 from "./DiscordMessage.vue?vue&type=style&index=0&id=1269b6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269b6d4",
  null
  
)

export default component.exports